export const TOTAL_STEPS = 5;
